export const MAP_SET_ADDRESS = "MAP_SET_ADDRESS";
export const MAP_SET_LOCATIONNAME = "MAP_SET_LOCATIONNAME";
export const MAP_SET_COUNTRY = "MAP_SET_COUNTRY";
